// LoadingProducts.jsx

import React from "react";
import { Log } from "@phosphor-icons/react";
import { Spinner } from "@phosphor-icons/react";
const LoadingComponent = ({ message }) => (
  <div
    style={{
      height: "100vh",
      justifyContent: "center",
      alignItems: "center",

    }}
    className="mt-20"
  >
    <div className="text-center">
      <Spinner size={48} className="mb-3 text-secondary-600" />
      <p className="h5">{message}</p>
    </div>
  </div>
);

export default LoadingComponent;
